import { Component, inject, type OnInit, signal, type WritableSignal } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { MaloupeEventName, MaloupeLocale } from '@malou-io/package-utils';

import { EventRestaurantDiagnosticSearchComponent } from ':modules/restaurant-diagnostic-search/event-restaurant-diagnostic-search/event-restaurant-diagnostic-search.component';
import { MainRestaurantDiagnosticSearchComponent } from ':modules/restaurant-diagnostic-search/main-restaurant-diagnostic-search/main-restaurant-diagnostic-search.component';
import { OtherLocalStorageKey } from ':shared/enums';

@Component({
    selector: 'app-restaurant-diagnostic-search',
    templateUrl: './restaurant-diagnostic-search.component.html',
    styleUrl: './restaurant-diagnostic-search.component.scss',
    imports: [
        FormsModule,
        MatAutocompleteModule,
        MatButtonModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatSelectModule,
        MatSlideToggleModule,
        ReactiveFormsModule,
        TranslateModule,
        EventRestaurantDiagnosticSearchComponent,
        MainRestaurantDiagnosticSearchComponent,
    ],
})
export class RestaurantDiagnosticSearchComponent implements OnInit {
    private readonly _activatedRoute = inject(ActivatedRoute);
    private readonly _router = inject(Router);

    readonly MaloupeEventName = MaloupeEventName;
    readonly eventName: WritableSignal<MaloupeEventName | null> = signal(null);

    readonly eventsToSetFrenchDefaultLanguage = [MaloupeEventName.FHT_2025];

    ngOnInit(): void {
        this._activatedRoute.queryParamMap.subscribe((params) => {
            const event = params.get('event_name');
            if (event) {
                const isValidEvent = Object.values(MaloupeEventName).includes(event as MaloupeEventName);
                if (isValidEvent && this._isEventActive(event as MaloupeEventName)) {
                    this._setDefaultLanguageForEvent(event as MaloupeEventName);
                    this.eventName.set(event as MaloupeEventName);
                    return;
                }
            }
            this._router.navigate(['/']);
        });
    }

    private _isEventActive(event: MaloupeEventName): boolean {
        // TODO: Add activation logic via growthbook [@hamza]
        switch (event) {
            case MaloupeEventName.FHT_2026:
                return true;
            case MaloupeEventName.FSTEC_2025:
            case MaloupeEventName.NRA_2025:
            case MaloupeEventName.EQUIP_HOTEL:
            case MaloupeEventName.FHT_2025:
                return false;
            default:
                return false;
        }
    }

    private _setDefaultLanguageForEvent(event: MaloupeEventName): void {
        if (this.eventsToSetFrenchDefaultLanguage.includes(event)) {
            // This will make sure that the language is set to French for event the first time
            // then will not change the language if the user changes it
            const isEventDefaultLanguageSet = localStorage.getItem(OtherLocalStorageKey.IS_EVENT_DEFAULT_LANGUAGE_SET);
            if (!isEventDefaultLanguageSet) {
                localStorage.setItem(OtherLocalStorageKey.LANG, MaloupeLocale.FR);
                localStorage.setItem(OtherLocalStorageKey.IS_EVENT_DEFAULT_LANGUAGE_SET, 'true');
                window.location.replace(location.pathname + location.search);
            }
        }
    }
}
